(function () {
  if (!window.B2B?.espressoIasi?.enabled) return;

  const TARGET_CATEGORIES = ["Single Origin", "Rarities"];

  async function checkCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const categoryData = {};

      cart.items.forEach(item => {
        const category = item.product_type;

        if (!TARGET_CATEGORIES.includes(category)) return;

        const kg = (item.grams * item.quantity) / 1000;
        const lineTotal = item.final_line_price / 100; // lei

        if (!categoryData[category]) {
          categoryData[category] = {
            kg: 0,
            subtotal: 0
          };
        }

        categoryData[category].kg += kg;
        categoryData[category].subtotal += lineTotal;
      });

      renderDiscount(categoryData);

    } catch (err) {
      console.error("B2B Espresso error:", err);
    }
  }
  function renderDiscount(categoryData) {
  const existingBox = document.querySelector('.espresso-discount');
  if (existingBox) existingBox.remove();

  const existingBtn = document.querySelector('.espresso-reopen');
  if (existingBtn) existingBtn.remove();

  const eligible = Object.entries(categoryData)
    .filter(([_, data]) => data.kg >= window.B2B.espressoIasi.minKg);

  // daca nu e eligibil, nu afisam nimic
  if (!eligible.length) {
    localStorage.removeItem('espressoBoxClosed');
    return;
  }

  // daca e inchis manual -> afisam doar butonul mic
  if (localStorage.getItem('espressoBoxClosed') === 'true') {
    createReopenButton();
    return;
  }

  const discountBox = document.createElement('div');
  discountBox.className = 'espresso-discount';

  discountBox.style.cssText = `
    position:fixed;
    bottom:80px;
    left:18px;
    z-index:9999;
    padding:18px;
    background:#64B2B8;
    color:#fff;
    border-radius:12px;
    font-size:14px;
    line-height:1.5;
    box-shadow:0 12px 30px rgba(0,0,0,0.25);
    max-width:240px;
  `;

  let html = `
    <div style="display:flex; justify-content:space-between; align-items:center;">
      <strong>🎉 15% B2B Discount</strong>
      <span class="espresso-close" style="cursor:pointer;font-size:16px;">✕</span>
    </div>
    <div style="font-size:12px;margin:10px 0;">
      la minimum 100 kg / categorie
    </div>
  `;

  eligible.forEach(([category, data]) => {
    const discountValue = data.subtotal * (window.B2B.espressoIasi.discountPercent / 100);
    const finalTotal = data.subtotal - discountValue;

    html += `
      <div style="margin-bottom:10px;">
        <strong>${category}</strong><br>
        ${data.kg.toFixed(1)}kg<br>
        Subtotal: ${data.subtotal.toFixed(2)} lei<br>
        Discount: -${discountValue.toFixed(2)} lei<br>
        <strong>Suma: ${finalTotal.toFixed(2)} lei</strong>
      </div>
    `;
  });

  discountBox.innerHTML = html;
  document.body.appendChild(discountBox);

  discountBox.querySelector('.espresso-close').addEventListener('click', () => {
    discountBox.remove();
    localStorage.setItem('espressoBoxClosed', 'true');
    createReopenButton();
  });
}

function createReopenButton() {
  const reopenBtn = document.createElement('div');
  reopenBtn.className = 'espresso-reopen';
  reopenBtn.innerHTML = '15% B2B Discount';

  reopenBtn.style.cssText = `
    position:fixed;
    bottom:80px;
    left:18px;
    z-index:9998;
    padding:10px 14px;
    background:#64B2B8;
    color:#fff;
    border-radius:12px;
    cursor:pointer;
    box-shadow:0 8px 20px rgba(0,0,0,0.2);
    font-size:13px;
  `;

  reopenBtn.addEventListener('click', () => {
    localStorage.removeItem('espressoBoxClosed');
    checkCart();
  });

  document.body.appendChild(reopenBtn);
}

  document.addEventListener('DOMContentLoaded', checkCart);
  document.addEventListener('input', checkCart);
  document.addEventListener('click', checkCart);
  document.addEventListener('cart:updated', checkCart);
})();
